function useLogout() {
  function onLogoutClick() {
    // destroy saved cart data
    /* istanbul ignore next */
    if (typeof window === 'object') {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem('reduxPersist:billing')
        window.sessionStorage.removeItem('reduxPersist:form')
        window.sessionStorage.removeItem('reduxPersist:travelers')
      }

      window.open('/wl/sso/logout', '_blank')
    }
  }

  return { onLogoutClick }
}

export default useLogout
